module.exports = __webpack_public_path__ + "img/nc-apprentice-logo.8159be1f.jpg";